import { ComponentProps, useMemo } from "react";
import { ColorThemeType, getRandomColorTheme } from "./ColorTheme";
import OrbGradient from "./OrbGradient";

const RandomOrbGradient = (props: ComponentProps<typeof OrbGradient>) => {
	const colorTheme: ColorThemeType = useMemo(() => getRandomColorTheme(), []);
	return <OrbGradient {...props} colorTheme={colorTheme} />;
};
export default RandomOrbGradient;
